import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/js/rem";
import "@xes/mx-ui/lib/mx-ui.css";
import "./assets/less/index.less";
import XesLoggerSDK from "@xes/xes_fe_log";
import cookie from "@/assets/js/cookie";
import api from "./api";
import { judgeUserAgent } from "@/utils/userAgent";
import checkoutIpxx from "@/utils/checkIsIpxx";
import { optionalChaining } from "./utils/chain";
import { getUrlParams } from "./utils/getUrlParams";
import { Toast, Divider, Sticky, List, Popup } from "vant";

Vue.use(Toast);
Vue.use(Divider);
Vue.use(Sticky);
Vue.use(List);
Vue.use(Popup);
Vue.config.productionTip = false;
Vue.prototype.$api = api;
// 注册一些全局变量
Vue.prototype.$isIOS = judgeUserAgent() === "ios"; // 是否ios机型
Vue.prototype.$isIpxx = checkoutIpxx(); // 是否iphone x 以上机型
Vue.prototype.$isInApp = /jzh/.test(navigator.userAgent); // 是否学而思网校app
Vue.prototype.$isWechat = /MicroMessenger\/[0-9]/i.test(navigator.userAgent); // 是否微信
Vue.prototype.$isQQ = /QQ\/[0-9]/i.test(navigator.userAgent); // 是否QQ
Vue.prototype.$$ = optionalChaining;
Vue.prototype.$EventBus = new Vue();
Vue.prototype.$isLoginFree = getUrlParams()?.isLoginFree === "1"; // 是否免登录

Vue.use(XesLoggerSDK, {
  common: {
    eventid: "renewal-center",
    userId: cookie.getCookie("stu_id") || "",
  },
  loadMsg: {
    open: false,
  },
  hashchange: {
    open: false,
    pvid: "hash",
    pageuid: {
      app: "ForApp",
      h5: "ForH5",
      change: "Change",
    },
  },
  appid: {
    "app.xueersi.com": {
      appid: 1004073,
      referer: "app.xueersi.com",
    },
  },
});
// 如果是非线上环境，加载 eruda(移动端调试)
// console.log(process.env.VUE_APP_ENV);
if (process.env.VUE_APP_ENV === "release") {
  const eruda = require("eruda/eruda.js");
  eruda.init();
}

if ("serviceWorker" in navigator) {
  try {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().then(() => {
          console.log("卸载成功");
        });
      });
    });
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  } catch (err) {
    console.log("卸载sw err", err);
  }
}

(async function () {
  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
    async mounted() {
      // 如果需要本地mock请自行打开注释
      if (process.env.NODE_ENV === "development") {
        Vue.config.devtools = true;
        // require("./mock.js");
      }
    },
  });

  app.$mount("#app");
})();
